import React, { useEffect, useRef, useState } from "react";
import { Table, Th, Button, Td, Tr, Count, ArrowButton, AddButton, ButtonPanel, Filter, Filters, ToggleContainer, ToggleInput, ToggleSlider, NoData, ScrollLayout, FilterBox, Actions, More, Status, ActionBox, IconBox, GroupHeader, ScrollContainerLayout, CasesContainer, CaseItem } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { RowContainer } from "../../styles/containers/styles";
import { AddIcon, ExcelIcon, FilterIcon, GetIcon, NextIcon, PreviousIcon, UploadIcon } from "../../../icons";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { deleteData, getData, postData, putData } from "../../../backend/api";
import CrudForm from "./create";
import { useTranslation } from "react-i18next";
import { addPageObject } from "../../../store/actions/pages";
import FormInput from "../input";
import Manage from "./manage";
import Loader from "../loader";
import Search from "../search";
import SubPage from "./subPage";
import DateRangeSelector from "../daterange";
import * as xlsx from "xlsx";
import { convertMinutesToHHMM } from "../../functions/minuteToHour";
import { dateFormat, dateTimeFormat, timeFormat } from "../../functions/date";
import { ToolTip } from "../../styles/list/styles";
import PopupView from "../popupview";
import { DisplayInformations } from "./popup";
import { Title } from "../../private/common/layout/header/styels";
import Drawer from "../drawer";
import Checkbox from "../checkbox";
import { ExportPopupContainer } from "../input/styles";
import NationalityChart from "../../private/pages/nationalities/chart";
import DynamicBarChart from "../chart";
const ListTable = ({ dragList = false, profileImage, viewDetails = true, formView = "normal", referenceId = 0, actions = [], api, setMessage, attributes = [], addPrivilege = true, delPrivilege = true, updatePrivilege = true,selectPrivilege=false ,shortName = "Item", itemTitle = "title", datefilter = false, bulkUplaod = false, pageKey = "", formMode = "single" , display=false, dataVal={},setRefreshVal,listHeadClass, moreOptions=false, reqDoc=false,popUpUsingId=false, cases=false, selectedDocsCategory=false,removeButtonPannel=false, chart="", page="",transformData}) => {
  const users = useSelector((state) =>
    state.pages[`${api}${referenceId === 0 ? "" : `/${referenceId}`}`]
      ? state.pages[`${api}${referenceId === 0 ? "" : `/${referenceId}`}`]
      : {
          data: null,
          isLoading: true,
          error: null,
        }
  );

  const user = useSelector((state) => state.login);

  const { i18n } = useTranslation();
  const [selectedLanguage] = useState(i18n.language || "de");
  let location = useLocation();
  const [showSublist, setShowSubList] = useState(false);
  const [currentApi] = useState(`${api}${referenceId === 0 ? "" : `/${referenceId}`}`);
  const [subAttributes, setSubAttributes] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentLimit, setCurrentLimit] = useState(15);
  const [count, setCount] = useState(0);
  const [showBulkUplad, setShowBulkUplad] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedValue, setSelectedValue] = useState({});

  const [groupedData, setGroupedData] = useState(null);
  const themeColors = useSelector((state) => state.themeColors);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation();
  
  const [showLoader, setShowLoader] = useState(false);
  const [currentAction, setCurrentAction] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [openData, setOpenData] = useState(false);
  const [pageLimitFilter] = useState({
    type: "select",
    placeholder: "pageLimitFilter",
    name: "pageLimitFilter",
    validation: "",
    default: "",
    label: "pageLimitFilter",
    required: false,
    view: false,
    tag: true,
    add: true,
    update: true,
    apiType: "JSON",
    selectApi: [
      { id: 15, value: "15" },
      { id: 25, value: "25" },
      { id: 50, value: "50" },
      { id: 75, value: "50" },
      { id: 100, value: "50" },
      { id: 0, value: t("all") },
    ],
  });
  /**
   * Function to set the showLoader state.
   * @param {boolean} status The status of the loader.
   */
  const setLoaderBox = (status) => {
    setShowLoader(status);
  };
  // processing attributes
  const [initialized, setInitialized] = useState(false);
  const [prevCrud, setPrevCrud] = useState("");
  const [formInput, setFormInput] = useState([]);
  const [errroInput, setErrorInput] = useState([]);
  const [addValues, setAddValues] = useState({});
  const [updateId, setUpdateId] = useState("");
  const [updateValues, setUpdateValues] = useState({});
  const [udpateView, setUpdateView] = useState(() => {});
  const [filterView, setFilterView] = useState({});
  const [data, setData] = useState(null);
  useEffect(() => {
    const addValuesTemp = {
      addValues: {},
      updateValues: {},
      viewValues: {},
      errorValues: {},
      filterValues: {},
    };
    let tempFilter = false;
    let date = new Date();

    attributes.forEach((item) => {
      if (item.type === "checkbox") {
        let bool = JSON.parse(item.default === "false" || item.default === "true" ? item.default : "false");
        if (item.add) {
          addValuesTemp.addValues[item.name] = bool;
        }
        addValuesTemp.updateValues[item.name] = bool;
      } else if (item.type === "multiSelect") {
        addValuesTemp.addValues[item.name] = [];
        addValuesTemp.errorValues[item.name] = [];
      } else if (item.type === "datetime" || item.type === "date" || item.type === "time") {
        if (item.default === "0") {
          // Set hour to 00:00
          date.setUTCHours(0, 0, 0, 0);
          addValuesTemp.updateValues[item.name] = date.toISOString();
        } else if (item.default === "1") {
          // Set hour to 23:59
          date.setUTCHours(23, 59, 0, 0);
          addValuesTemp.updateValues[item.name] = date.toISOString();
        } else {
          // Set hour to current time
          addValuesTemp.updateValues[item.name] = date.toISOString();
        }
        if (item.add) {
          addValuesTemp.addValues[item.name] = item.default === "empty" ? "" : date.toISOString();
        }
      } else if (item.type === "image" || item.type === "file") {
        if (item.add) {
          addValuesTemp.addValues[item.name] = "";
          addValuesTemp.addValues["selected_" + item.name] = [];
        }
        addValuesTemp.updateValues[item.name] = "";
        addValuesTemp.updateValues["selected_" + item.name] = [];
      } else {
        if (item.add) {
          addValuesTemp.addValues[item.name] = item.default;
        }
        addValuesTemp.updateValues[item.name] = item.default;
        if (item.type === "select") {
          if ((item.filterType ?? "multiSelect") === "multiSelect") {
            addValuesTemp.filterValues[item.name] = item.default?.length > 0 ? [item.default] : [];
          } else {
            addValuesTemp.filterValues[item.name] = item.default;
          }
          tempFilter = true;
        }
      }
      addValuesTemp.errorValues[item.name] = "";
      addValuesTemp.filterValues["searchkey"] = "";
    });

    setFormInput(attributes);
    setAddValues(addValuesTemp.addValues);
    setErrorInput(addValuesTemp.errorValues);
    setUpdateValues(addValuesTemp.updateValues);
    setFilterView(addValuesTemp.filterValues);
    setFilter(tempFilter);
    setInitialized(true);
  }, [attributes, dispatch]);

  // end processing attributes
  useEffect(() => {
    setLoaderBox(users.isLoading);
    if (currentIndex === 0 && users.data?.count) {
      setCount(users.data.count);
    }
    if (currentIndex === 0 && users.data?.groupedData) {
      console.log(users.data.groupedData);
      if(chart){
        let temp = [];
        users.data.groupedData.forEach((item) => {
          item.items.forEach((data) => {
            temp.push({
              ...data
            });
          });
        });
        console.log(temp);
        setData(temp);
        setGroupedData([])
      }
      else{
        setGroupedData(users.data.groupedData ?? []);
        setCount(0);
      }
    }
    users.data?.data && !(users.data?.groupedData) && setData(users.data.data);
  }, [users, currentIndex]);

  useEffect(() => {
    if (initialized) {
      if(selectedDocsCategory){
        let payload = {...filterView, folderType: selectedDocsCategory}
        dispatch(addPageObject(currentApi, currentIndex, currentLimit, payload, navigate));
      }
      else{
        dispatch(addPageObject(currentApi, currentIndex, currentLimit, filterView, navigate));
      }
    }
  }, [initialized, currentApi, currentIndex, currentLimit, dispatch, filterView, navigate, selectedDocsCategory]);
  const refreshView = (currentIndex) => {
    try {
      if(selectedDocsCategory){
        let payload = {...filterView, folderType: selectedDocsCategory}
        dispatch(addPageObject(currentApi, currentIndex, currentLimit, payload, navigate));
      }
      else{
        dispatch(addPageObject(currentApi, currentIndex, currentLimit, filterView, navigate));
      }
    } catch {}
  };
  const toExcel = (currentIndex) => {
    try {
      exportToExcel();
    } catch (error) {
      console.log(error);
    }
  };
  //crud functions
  const [isCreating, setIsCreating] = useState(false);
  const isCreatingHandler = (value, callback) => {
    if (isCreating) {
      setUpdateView(() => callback);
      setIsCreating(false);
      navigate({}, "", window.location.pathname);
    } else {
      // formInput.forEach((item) => {
      //   if (item.add) {
      //     if((shortName==="wageType" || shortName==="holiday") && user.data?.user?.role?.toLowerCase()==="admin"){
      //       item["disabled"] = false;
      //     }
      //   }
      // });

      // if((shortName==="wageType" || shortName==="holiday") && formInput.find((item)=> item.name==="isActive") && user.data?.user?.role?.toLowerCase()==="admin"){
      //   let index = formInput.findIndex((item)=> item.name==="isActive")
      //   if(index!==-1)
      //     formInput.splice(index, 1);
      // }
      window.location.hash = "add";
      setIsCreating(true);
    }
  };

  const [isEditing, setIsEditing] = useState(false);
  const isEditingHandler = (value, callback) => {
    setLoaderBox(true);
    if (!isEditing) {
      setUpdateView(() => callback);
      const updateValues = {};
      setUpdateId(value?._id);
      formInput.forEach((item) => {
        if (item.update) {
          
          // if((shortName==="wageType" || shortName==="holiday") && user.data?.user?.role?.toLowerCase()==="admin" && value?.isMasterData){
          //   item["disabled"] = true;
          // } else{
          //   item["disabled"] = false;
          // }

          if (item.type === "checkbox") {
            let bool = value[item.name] ? (value[item.name].toString() === "true" ? true : false) : false;
            updateValues[item.name] = bool;
          } else if (item.type === "number") {
            let bool = parseInt(value[item.name]);
            updateValues[item.name] = bool;
          } else if (item.type === "select") {
            updateValues[item.name] = typeof value[item.name] === "undefined" ? "" : typeof value[item.name] === "string" || typeof value[item.name] === "number" ? value[item.name] : value[item.name]?._id ? value[item.name]._id : "";
          } else if (item.type === "multiSelect") {
            updateValues[item.name] = Array.isArray(value[item.name]) ? value[item.name] : [];
          } else if (item.type === "image") {
            updateValues["selected_" + item.name] = [];
            updateValues[item.name] = value[item.name] ? value[item.name] : "";
          } else {
            updateValues[item.name] = (value && value[item.name]) ? value[item.name] : "";
          }
        }
      });

      // if((shortName==="wageType" || shortName==="holiday") && value?.isMasterData && attributes.find((item)=> item.name==="isActive")===undefined && user.data?.user?.role?.toLowerCase()==="admin"){
      //   formInput.push(
      //     {
      //       type: "checkbox",
      //       placeholder: "active",
      //       name: "isActive",
      //       validation: "",
      //       showItem: "",
      //       default: "",
      //       label: "active",
      //       required: false,
      //       view: false,
      //       tag: true,
      //       add: false,
      //       update: true,
      //       filter: false,
      //     }
      //   )
      // }

      // if(!(value?.isMasterData) && (shortName==="wageType" || shortName==="holiday") && user.data?.user?.role?.toLowerCase()==="admin"){
      //   let index = formInput.findIndex((item)=> item.name==="isActive")
      //   if(index!==-1)
      //     formInput.splice(index, 1);
      // }

      setUpdateValues(updateValues);
      setIsEditing(true);
      window.location.hash = "edit";
    } else {
      setUpdateId("");
      navigate({}, "", window.location.pathname);
      setIsEditing(false);
    }
    setLoaderBox(false);
  };
  const deleteHandler = async (item, id = "") => {
    console.log(item);
    await deleteData({}, currentApi, id, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t("deleted", { shortName: (t(item.title ? item.title : shortName)==="Abwesenheiten" && window.location.pathname==="/settings") ? "Abwesenheit" : t(shortName) }), proceed: t("okay"), code: 200 });
          setCount((count) => count - 1);
          setIsCreating(false);
          setIsEditing(false);
          refreshView();
          // udpateView(0);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  };
  const [action, setActions] = useState([]);
  const openAction = (item, data) => {
    // Actions Window
    setActions({ item, data });
    // setMessage({ type: 1, content: item.title + " / " + data._id, proceed: "Okay" });
  };
  const submitHandler = async (data) => {
    setLoaderBox(true);
    console.log("form data", data);
    await postData(data, currentApi==="leave-request" ? "user/addAbsence" : currentApi, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          // setMessage({ type: 1, content: `The '${t(shortName)}' saved successfully!`, proceed: "Okay" });
            setMessage({ type: 1, content: t("saved", { shortName: (t(shortName)==="Abwesenheiten" && window.location.pathname==="/settings") ? "Abwesenheit" : t(shortName)}), proceed: "Okay", code: 200 });
          setIsCreating(false);
          if(setRefreshVal)
            setRefreshVal(true);
          refreshView();
          // udpateView(0);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  };

  const updateHandler = async (data) => {
    setLoaderBox(true);
    let payload = { ...data };
    attributes
      .filter((attribute) => attribute.type === "multiSelect")
      .forEach((item) => {
        if (Array.isArray(payload[item.name]) && payload[item.name].length > 0) {
          payload[item.name] = payload[item.name].map((value) =>
            typeof value === "object" && value._id ? value._id : value
          );
        }
        
      });

    await putData(payload, `${currentApi}/${updateId}`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t("updated", { shortName: (t(shortName)==="Abwesenheiten" && window.location.pathname==="/settings") ? "Abwesenheit" : t(shortName) }), proceed: "Okay", code: 200 });
          refreshView(currentIndex);
          if(setRefreshVal)
            setRefreshVal(true);
          setIsEditing(false);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        alert(error);
        setLoaderBox(false);
      });
  };

  const filterChange = (sl, option, name) => {
    let items = filterView[name];
    if (Array.isArray(items)) {
      const index = items.findIndex((item) => item === option.id);
      if (index === -1) {
        // If option._id doesn't exist, push it to the items array
        items.push(option.id);
      } else {
        // If option._id already exists, remove it from the items array
        items.splice(index, 1);
      }
      const updateValue = {
        ...filterView,
        [name]: items,
      };
      console.log(updateValue);
      setFilterView(updateValue);
    } else {
      const updateValue = {
        ...filterView,
        [name]: option.id,
      };
      console.log(updateValue);
      setFilterView(updateValue);
    }
  };

  const pageLimitFilterChange = (option, name) => {
    setCurrentLimit(option.id);
  };
  const dateRangeChange = (item) => {
    const startDate = new Date(item.startDate);
    startDate.setHours(0, 0, 0, 0); // Set start date to 00:00

    const endDate = new Date(item.endDate);
    endDate.setHours(23, 59, 59, 999); // Set end date to 23:59
    const udpateValue = {
      ...filterView,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
    // updating the formm values
    setFilterView(udpateValue);
  };
  const closeManage = () => {
    setActions([]);
  };

  //export to excel
  const exportToExcel = () => {
    // JSON data to be converted to Excel
    const jsonData = Object.values(selectedValue).some(value => value) ? users.data.data.filter(item => selectedValue[item._id])
    : users.data.data;
    if (jsonData) {
      // Convert JSON to worksheet
      const excelData = [];
      let userId = "";
      jsonData.forEach((data) => {
        const excelRow = {};

        attributes.forEach((attribute) => {
          if (attribute.view && exportAttributes[attribute.name] && exportAttributes[attribute.name]=== true) {
            const name = t(attribute.label);
            switch (attribute.type) {
              case "view":
                return (excelRow[name] = data[attribute.collection][attribute.showItem] ?? "No Data");
              case "minute":
                return (excelRow[name] = convertMinutesToHHMM(parseFloat(data[attribute.name] ?? 0)));
              case "datetime":
                return (excelRow[name] = data[attribute.name] ? dateTimeFormat(data[attribute.name]) : "N/A");
              case "date":
                return (excelRow[name] = data[attribute.name] ? dateFormat(data[attribute.name]) : "N/A");
              case "time":
                return (excelRow[name] = data[attribute.name] ? timeFormat(data[attribute.name]) : "N/A");
              case "select":
                if (attribute.apiType === "JSON") {
                  return (excelRow[name] = attribute.selectApi.filter((item) => item.id.toString() === data[attribute.name]?.toString()).map((filteredItem, index) => filteredItem.value));
                } else if (attribute.apiType === "CSV") {
                  return (excelRow[name] = data[attribute.name]);
                } else {
                  return (excelRow[name] = data[attribute.name]?.[attribute.showItem] ?? "Nil");
                }

              default:
                switch (typeof data[attribute.name]) {
                  case "undefined":
                    return (excelRow[name] = "Not Found");
                  case "object":
                    return (excelRow[name] = objectValueReturn(data, attribute));
                  case "boolean":
                    return (excelRow[name] = data[attribute.name].toString());
                  case "string":
                  case "number":
                  default:
                    if (attribute.type === "select" && attribute.apiType === "JSON") {
                      return attribute.selectApi.filter((item) => item.id.toString() === data[attribute.name]?.toString()).map((filteredItem) => (excelRow[name] = filteredItem.value));
                    } else {
                      return (excelRow[name] = data[attribute.name]?.toString().substring(0, 200));
                    }
                }
            }
          }
        });
        if (pageKey === "page-report3") {
          if (userId !== data?._id?.user?._id) {
            if (userId !== "") {
              excelData.push({});
              excelData.push({});
              excelData.push({});
            }
          }

          userId = data?._id?.user?._id;
        }
        excelData.push(excelRow);
      });
      if (pageKey === "page-report3") {
        excelData.push({});
        excelData.push({});
        excelData.push({});
      }
      const worksheet = xlsx.utils.json_to_sheet(excelData);

      // Create workbook
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, t("report"));
      // Convert workbook to Excel binary and download the file
      xlsx.writeFile(workbook, t(shortName) + "-data.xlsx");
    }
  };

  const handleDragStart = (e, id, sequence) => {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", id + "-" + sequence);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = async (e, index, sequence) => {
    e.preventDefault();

    // Retrieve the dragged data and split it
    let dataValue = e.dataTransfer.getData("text/plain");
    dataValue = dataValue.split("-");
    const draggedRowId = parseInt(dataValue[0]);
    // const draggedSequence = parseFloat(dataValue[1]);

    // Find the index of the dragged and dropped rows
    const lastRow = data[index - 1] ?? { sequence: 0 };
    const droppedRow = data[index];

    // Copy data to update it
    const updatedRows = [...data];

    // Remove the dragged row and get it
    const [draggedRow] = updatedRows.splice(draggedRowId, 1);
    updatedRows.splice(index, 0, draggedRow);
    // Update the sequence of the dragged row
    console.log(draggedRowId, index);

    updatedRows[index].sequence = lastRow.sequence ?? 0;
    updatedRows[index + 1].sequence = (lastRow.sequence ?? 0) + 0.001;

    // Insert the dragged row at the new position

    // Update the state with the modified data

    setData(updatedRows);
    await putData({ sequence: draggedRow.sequence }, `${api}/${draggedRow._id}`);
    await putData({ sequence: droppedRow.sequence }, `${api}/${droppedRow._id}`);
  };

  const objectValueReturn = (data, attribute) => {
    if (attribute.showItem && data[attribute.name]?.[attribute.showItem]) {
      return data[attribute.name][attribute.showItem];
    } 
    else if(attribute.showItem==="locale" && data[attribute.name]){
      return data[attribute.name][localStorage.getItem("_lang") ?? "de"];
    }
    else if (!attribute.showItem && data[attribute.name]) {
      // Check if the key of data matches specific known keys
      if (["countryOfBirth", "country", "nationality", "workDays", "religion"].includes(attribute.name)) {
        return data[attribute.name][localStorage.getItem("_lang") ?? "de"];
      } 
      else if (attribute.name === "company") {
        return data[attribute.name]?.organization;
      } 
      else if (attribute.name === "terminationBy") {
        return data[attribute.name]?.name;
      } 
      else {
        return data[attribute.name]?.title ?? "Nil";
      }
    } 
    else {
      return "Nil";
    }
  };
  

  useEffect(() => {
    if(display){
      setOpenData({ actions, attributes, data:dataVal });
      setSubAttributes({ actions, attributes, data:dataVal });
    }
  }, [display])

  const [searchParams] = useSearchParams();
    const paramValue = searchParams.get('id');
  
  useEffect(() => {
    
      if (paramValue && data && data.length>0 && popUpUsingId) {
        setShowDetails(true);
        if(data?.find((val)=> val._id===paramValue)){
          setOpenData({ actions, attributes, data: data?.find((val)=> val._id===paramValue) });
          setSubAttributes({ actions, attributes, data: data?.find((val)=> val._id===paramValue) });
        }
        else{
          fetchParamsData({actions, attributes})
        }
      }
    }, [window.location.pathname, paramValue,data]);

    const fetchParamsData = async ({actions, attributes}) => {
      try {
        await getData({ id: paramValue }, currentApi, dispatch, navigate)
      .then((response) => {
        setOpenData({ actions, attributes, data: response.data });
          setSubAttributes({ actions, attributes, data: response.data });
      })
      .catch((error) => {
        console.log(error);
        setOpenData({ actions, attributes, data: {} });
          setSubAttributes({ actions, attributes, data:{} });
      });
      } catch (error) {
        console.log(error);
        
      }
    }

  //export to excel end
  const TableRowWithActions = ({ attributes, data, slNo, pinnedRows }) => {
    // data[attribute.name]?.title ? data[attribute.name]?.title : data[attribute.name]?.toString()
    const [isDragOver, setIsDragOver] = useState(false);

    selectRef.current[slNo] = useRef(null);
    let acctionCount = actions.filter((item) => item.element === "button" && item.type !== "subList").length;
    const openRowData = () => {
      setShowDetails(true);
      setOpenData({ actions, attributes, data });
      setSubAttributes({ actions, attributes, data });
    };
    return (
      <Tr
        draggable={dragList}
        onDragStart={
          dragList
            ? (e) => {
                handleDragStart(e, slNo, data.sequence ?? 0);
              }
            : null
        }
        isDragOver={isDragOver}
        onDragOver={
          dragList
            ? (e) => {
                handleDragOver(e);
                setIsDragOver(true);
              }
            : null
        }
        onDragLeave={() => {
          setIsDragOver(false);
        }}
        onDrop={dragList ? (e) => handleDrop(e, slNo, data.sequence ?? 0) : null}
        key={`${shortName}-${slNo}-${pinnedRows}`}
        className={`${pinnedRows ? "no-border pinned" : "no-border"} ${!!selectedValue[data._id] ? "selected" : ""}`}
      >
        {/* <td>{data.sequence}</td> */}
        {selectPrivilege && (<Td key={`actions-${shortName}-${data._id}`} style={{ zIndex: (pinnedRows === true ? count * 2 : count) + 100 - slNo }} className={`${!!selectedValue[data._id] ? "selected" : ""} actions`}>
          <ActionBox>
            
              <More
                key={`select-${data._id}`}
                className="selected-privilege"
              >
                {/* <FormInput placeholder={""} key={`input` + slNo} id={data._id} index={slNo} value={selectedValue[data._id] && selectedValue[data._id]} type="checkbox" onChange={handleSelectedValue} />  */}
                <Checkbox theme={themeColors} checked={selectedValue[data._id] && selectedValue[data._id]} onChange={(event) => setSelectedValue({...selectedValue, [data._id]: event.target.checked})} className="medium"></Checkbox>
              </More>
          </ActionBox>
        </Td>)}
        {attributes.map((attribute, index) => {
          let itemValue;
          if (attribute.type === "expired" && attribute.showItem === "contractEnd") {
            if (data.contractEnd === null && data.contractFrom !== null) {
                itemValue = new Date(data.contractFrom) <= new Date() ? new Date(new Date().setDate(new Date().getDate() + 1)) : null;
            } else if (data.contractEnd === null && data.contractFrom === null) {
                itemValue = new Date(new Date().setDate(new Date().getDate() + 1));
            } else {
              itemValue = new Date(data.contractEnd) >= new Date() ? new Date(data.contractEnd) : null;
            }
          } else if (attribute.collection?.length > 0 && attribute.showItem?.length > 0) {
            itemValue = data[attribute.collection]?.[attribute.showItem];
          } else {
            itemValue = data[attribute.name];
          }
          let type = attribute.type;
          if (attribute.view === true) {
            if (attribute.type === "mixed") {
              type = data["fieldType"];
            }
            if (attribute.type === "select" && attribute?.showItem === "locale") {
              itemValue = attribute.showItem?.length > 0 ? data[attribute.name]?.[selectedLanguage] ?? "" : data[attribute.name];
              return (
                <Td onClick={openRowData} key={index}>
                  {t(itemValue)}
                </Td>
              );
            }
            try {
              if (itemValue?.length === 0) {
                return (
                  <Td onClick={openRowData} key={index}>
                    {t(`na`)}
                  </Td>
                );
              }
              switch (type) {
                case "translate":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {t(itemValue)}
                    </Td>
                  );
                case "text":
                case "view":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {t(itemValue)}
                    </Td>
                  );
                case "minute":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {convertMinutesToHHMM(parseFloat(itemValue ?? 0))}
                    </Td>
                  );
                case "image":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {/* <Img src={`https://d2ko9fbemypq1w.cloudfront.net/${parent[attribute.name]}`} /> */}
                    </Td>
                  );
                case "file":
                  return (
                    <Td key={index} onClick={openRowData}>
                      <div
                        style={{ width: "20px", cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault(); // Prevent the default link behavior
                          const link = document.createElement("a");
                          link.href = process.env.REACT_APP_CDN + itemValue;
                          link.target = "_blank"; // Open in a new page/tab
                          link.download = ""; // You can set the desired download filename here
                          link.style.display = "none";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                      >
                        <GetIcon icon={"Download"}></GetIcon>
                      </div>
                    </Td>
                  );

                case "datetime":
                  let userFriendlyDateTime = itemValue ? dateTimeFormat(itemValue) : "N/A";
                  return (
                    <Td onClick={openRowData} key={index}>
                      {userFriendlyDateTime}
                    </Td>
                  );
                case "icon":
                  return (
                    <Td key={index} className={itemValue}>
                      <GetIcon onClick={openRowData} icon={itemValue}></GetIcon>
                    </Td>
                  );
                case "date":
                  let userFriendlyDate = itemValue ? dateFormat(itemValue) : "N/A";
                  return (
                    <Td onClick={openRowData} key={index}>
                      {userFriendlyDate}
                    </Td>
                  );
                case "expired":
                  let status;

                    if (typeof itemValue === 'string') {
                    // Check if it's a valid date string
                    const dateObj = new Date(itemValue);
                    if (!isNaN(dateObj.getTime())) {
                      // It's a date string
                      status = dateObj > new Date()
                      ? <Status color={"green"}>{t("active")}</Status>
                      : <Status color={"red"}>{t("inactive")}</Status>;
                    } else {
                      // Handle string cases ("open" or "close")
                      if (itemValue.toLowerCase() === 'open') {
                      status = <Status color={"green"}>{t("open")}</Status>;
                      } else if (itemValue.toLowerCase() === 'close') {
                      status = <Status color={"red"}>{t("close")}</Status>;
                      } else {
                      status = <Status color={"red"}> {t(attribute.ifNull)}</Status>;
                      }
                    }
                    } else if (itemValue instanceof Date || !isNaN(new Date(itemValue))) {
                    // Handle date cases
                    status = new Date(itemValue) > new Date()
                      ? <Status color={"green"}>{t("active")}</Status>
                      : <Status color={"red"}>{t("inactive")}</Status>;
                    } else {
                    // Handle null/undefined or other cases
                    status = <Status color={"red"}> {t(attribute.ifNull)}</Status>;
                    }

                  return (
                    <Td onClick={openRowData} key={index}>
                      {status}
                    </Td>
                  );
                case "time":
                  return (
                    <Td onClick={openRowData} key={index}>
                      {itemValue ? timeFormat(itemValue) : "N/A"}
                    </Td>
                  );
                case "color":
                  return (
                    <Td onClick={openRowData} key={index}>
                      <div style={{ backgroundColor: itemValue, height: "20px", width: "40px" }}></div>
                    </Td>
                  );
                case "textarea":
                  return <Td onClick={openRowData} key={index} dangerouslySetInnerHTML={{ __html: data[attribute.name]?.substring(0, 200) }}></Td>;
                case "checkbox":
                  return (
                    <Td onClick={openRowData} key={index}>
                      <IconBox className={"display"}>{itemValue ? <GetIcon icon={"checked"} /> : <GetIcon icon={"Close"} />}</IconBox>
                    </Td>
                  );

                case "select":
                  if (attribute.apiType === "JSON") {
                    const item = attribute.selectApi
                      .filter((item) => item.id.toString() === data[attribute.name]?.toString())
                      .map((filteredItem, index) => (
                        <Td onClick={openRowData} style={{ color: filteredItem.color }} key={index}>
                          {t(filteredItem.value)}
                        </Td>
                      ));
                    return item.length > 0 ? item : <Td>N/A</Td>;
                  } else if (attribute.apiType === "CSV") {
                    return (
                      <Td onClick={openRowData} key={index}>
                        {data[attribute.name] ?? "Nil"}
                      </Td>
                    );
                  } else {
                    return (
                      <Td onClick={openRowData} key={index}>
                        {t(data[attribute.name]?.[attribute.showItem] ?? "Nil")}
                      </Td>
                    );
                  }

                  case "multiSelect":
                  if (attribute.apiType === "JSON") {
                    const item = attribute.selectApi
                      .filter((item) => item.id.toString() === data[attribute.name]?.toString())
                      .map((filteredItem, index) => (
                        <Td onClick={openRowData} style={{ color: filteredItem.color }} key={index}>
                          {t(filteredItem.value)}
                        </Td>
                      ));
                    return item.length > 0 ? item : <Td>N/A</Td>;
                  } else if (attribute.apiType === "CSV") {
                    return (
                      <Td onClick={openRowData} key={index}>
                        {data[attribute.name] ?? "Nil"}
                      </Td>
                    );
                  } else {
                    return (
                      <Td onClick={openRowData} key={index}>
                        {data[attribute.name]?.map((val,idx)=> {
                          if(idx===data[attribute.name]?.length-1){
                            return t(val[attribute.showItem] ?? "Nil")
                          }
                          else{
                            return t(val[attribute.showItem] ?? "Nil")+", "
                          }
                         }) }
                      </Td>
                    );
                  }
                default:
                  switch (typeof data[attribute.name]) {
                    case "undefined":
                      return (
                        <Td onClick={openRowData} key={index}>
                          {t(`na`)}
                        </Td>
                      );
                    case "object":
                      return (
                        <Td onClick={openRowData} key={index}>
                          {objectValueReturn(data, attribute)}
                        </Td>
                      );
                    case "boolean":
                      return (
                        <Td onClick={openRowData} key={index}>
                          {data[attribute.name].toString()}
                        </Td>
                      );
                    case "string":
                    case "number":
                    default:
                      if (attribute.type === "select" && attribute.showItem === "locale") {
                        return (
                          <Td onClick={openRowData} key={index}>
                            {data[attribute.name][localStorage.getItem("language") ?? "de"]}
                          </Td>
                        );
                      } else if (attribute.type === "select" && attribute.apiType === "JSON") {
                        const item = attribute.selectApi
                          .filter((item) => item.id.toString() === data[attribute.name]?.toString())
                          .map((filteredItem) => (
                            <Td onClick={openRowData} style={{ color: filteredItem.color }} key={index}>
                              {t(filteredItem.value)}
                            </Td>
                          ));
                        // console.log(attribute.naneitem);
                        return item ?? <Td>{t(`na`)}</Td>;
                      } else {
                        return (
                          <Td onClick={openRowData} key={index}>
                            {data[attribute.name]?.toString().substring(0, 200)}
                          </Td>
                        );
                      }
                  }
              }
            } catch (error) {
              console.log(error);
              if (type === "expired") {
                return (
                  <Td onClick={openRowData} key={index}>
                    <Status color={"red"}> {t(attribute.ifNull ?? "N/A")}</Status>
                  </Td>
                );
              } else {
                return <Td onClick={openRowData}>{t(`na`)}</Td>;
              }
            }
          } else {
            return null;
          }
        })}
        {console.log(data, user)}
        <Td key={`actions-${shortName}-${data._id}`} style={{ zIndex: (pinnedRows === true ? count * 2 : count) + 100 - slNo }} className="actions">
          <ActionBox>
            {updatePrivilege && (data?.isMasterData ? user?.data?.user?.role?.toLowerCase()==="super" : true) && (
              <More
                key={`edit-${data._id}`}
                onClick={() => {
                  isEditingHandler(data, udpateView);
                }}
                className="edit"
              >
                <GetIcon icon={"edit"} />
              </More>
            )}
            {/* {delPrivilege && (
              <More
              key={`delete-${data._id}`}
              onClick={() => {
                setMessage({
                  type: 2,
                  content: t("deleteRequest", { label: data[itemTitle] ? data[itemTitle].toString() : "Item" }),
                  proceed: t("delete"),
                  onProceed: deleteHandler,
                  data: data,
                  });
                }}
                className="delete"
              >
                <GetIcon icon={"delete"} />
              </More>
            )} */}

            {actions.map((item) => {
              return (
                item.element !== "button" &&
                (item.element === "toggle" ? (
                  <ToggleContainer key={`${item.id}-${data._id}`}>
                    <ToggleInput
                      type="checkbox"
                      checked={data[item.id]}
                      onChange={async (event) => {
                        // item.callback(item, data);
                        setLoaderBox(true);
                        await postData({ status: event.target.checked }, `${item.api}/${data._id}`, dispatch, navigate)
                          .then((response) => {
                            if (response.status === 200) {
                              if (response.data?.message) {
                                setMessage({ type: 1, content: t(response.data?.message), proceed: t("okay"), code: 200 });
                              }
                              //
                              refreshView();
                              // setIsEditing(false);
                            } else if (response.status === 404) {
                              refreshView();
                              setMessage({ type: 1, content: t("error"), proceed: "Okay", code: 404 });
                            } else {
                              refreshView();
                              setMessage({ type: 1, content: t("error"), proceed: "Okay", code: 500 });
                            }
                            // setLoaderBox(false);
                          })
                          .catch((error) => {
                            alert(error);
                            // setLoaderBox(false);
                          });
                      }}
                    />
                    <ToggleSlider />
                  </ToggleContainer>
                ) : (
                  <More
                    key={`${slNo}-action-new`}
                    onClick={() => {
                      if (item.type === "callback") {
                        item.callback(item, data, refreshView);
                      } else if (item.type === "call") {
                        window.location.href = `tel:${data.mobileNumber}`;
                      } else if (item.type === "subList") {
                        setSubAttributes({ item, data });
                        setShowSubList(true);
                      } else {
                        openAction(item, data);
                      }
                    }}
                  >
                    <GetIcon icon={item.icon}></GetIcon>
                  </More>
                ))
              );
            })}
            {viewDetails === true && (
              <More onClick={openRowData}>
                <GetIcon icon={"open"}></GetIcon>
              </More>
            )}
            <div
              ref={selectRef.current[slNo]}
              onClick={() => {
                setCurrentAction(slNo);
              }}
            >
              {acctionCount > 0 && (
                <>
                  <More className={currentAction === slNo ? `active` : ``}>
                    <GetIcon icon={"dots"}></GetIcon>
                  </More>

                  <ToolTip className={currentAction === slNo ? `actions` : `actions hide`}>
                    <Actions>
                      {actions.map((item) => {
                        return (
                          item.element === "button" && (
                            <Button
                              key={`custom-${item.id}-${data._id}`}
                              onClick={() => {
                                if (item.type === "callback") {
                                  item.callback(item, data);
                                } else if (item.type === "call") {
                                  window.location.href = `tel:${data.mobileNumber}`;
                                } else if (item.type === "subList") {
                                  setSubAttributes({ item, data });
                                  setShowSubList(true);
                                } else {
                                  openAction(item, data);
                                }
                              }}
                              className="edit"
                            >
                              <GetIcon icon={item.icon} />
                              <span>{t(item.title)}</span>
                            </Button>
                          )
                        );
                      })}
                    </Actions>
                  </ToolTip>
                </>
              )}
            </div>
          </ActionBox>
        </Td>
        {data?.requestDocs && !data?.file && reqDoc && <Td key={`actions-${shortName}-${data._id}`} style={{ zIndex: (pinnedRows === true ? count * 2 : count) + 100 - slNo }}>
          <ActionBox onClick={() => {
                  isEditingHandler(data, udpateView);
                }}
                className="edit" style={{color:'red'}}>
            Request
          </ActionBox>
        </Td>}
      </Tr>
    );
  };
  const closeModal = () => {
    setShowSubList(false);
  };
  const [searchValue, setSearchValue] = useState("");
  const [filter, setFilter] = useState(false);
  const searchTimeoutRef = useRef();
  const handleChange = (event) => {
    clearTimeout(searchTimeoutRef.current);
    setSearchValue(event.target.value);
    searchTimeoutRef.current = setTimeout(() => {
      setFilterView({ ...filterView, searchkey: event.target.value });
    }, 300);
  };
  useEffect(() => {
    return () => {
      clearTimeout(searchTimeoutRef.current);
    };
  }, []);
  const selectRef = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideRefs = selectRef.current.filter((ref) => ref.current && ref.current.contains(event.target));

      if (clickedInsideRefs.length === 0) {
        setCurrentAction("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const selectedMenu = useSelector((state) => state.selectedMenu);
  const [exportPopup, setExportPopup] = useState(false);
  const [exportAttributes, setExportAttributes] = useState({});

  const fetchChartData = (dispatch, navigate) =>
    getData({}, chart, dispatch, navigate);

  return (
    <RowContainer className={`list ${listHeadClass??""} ${cases ? "cases" : ""}`}>
      {(page && page==="profile") ? !display && <Title className="inner">
        <GetIcon icon={shortName}></GetIcon>
        {t(shortName)}
      </Title>:
      !display && <Title className="inner">
        <GetIcon icon={selectedMenu.icon}></GetIcon>
        {t(selectedMenu.label)}
      </Title>}
      {(display || removeButtonPannel) ? null : <ButtonPanel className={`${groupedData?.length>0?"groupedData":""}`}>
        <FilterBox>
          <Search theme={themeColors} placeholder="Search" value={searchValue} onChange={handleChange}></Search>
          {filter && (
            <Filter
              theme={themeColors}
              onClick={() => {
                refreshView(currentIndex);
              }}
            >
              <GetIcon icon={"reload"} />
            </Filter>
          )}
          <Filter
            theme={themeColors}
            onClick={() => {
              setMessage({ type: 2, content: t("export"), proceed: t("exportNow"), onProceed: toExcel, data: currentIndex });
            }}
          >
            <ExcelIcon />
          </Filter>
          {datefilter && <DateRangeSelector onChange={dateRangeChange} themeColors={themeColors}  ></DateRangeSelector>}
        </FilterBox>
        <Filters className="right">
        {/* {(bulkUplaod ? bulkUplaod : false) && (
          <AddButton onClick={() => setShowBulkUplad((prev) => !prev)}>
            <UploadIcon></UploadIcon>
            <span>{t("bulkUpload", { label: t(shortName) })}</span>
          </AddButton>
        )} */}
        {((addPrivilege && !moreOptions) ? true : false) && (
          <AddButton style={{marginLeft:0}} onClick={() => isCreatingHandler(true, refreshView)}>
            <AddIcon></AddIcon>
            <span>{t("addNew", { label: t(shortName) })}</span>
          </AddButton>
        )}
        {(moreOptions ? moreOptions : false) && (
          <AddButton className="more">
            <AddIcon></AddIcon>
            <div style={{ display: "none" }}>
            {(addPrivilege ? addPrivilege : false) && (
              <AddButton style={{marginLeft:0}} onClick={() => isCreatingHandler(true, refreshView)}>
                <AddIcon></AddIcon>
                <span>{t("addNew", { label: t(shortName) })}</span>
              </AddButton>
              )}
              <AddButton style={{marginLeft:0}} onClick={() => {}} >{t("sendMail")}</AddButton>
              {/* <AddButton onClick={() => setShowBulkUplad((prev) => !prev)}>{t("bulkUpload")}</AddButton> */}
              <AddButton style={{marginLeft:0}} 
            onClick={()=> {
              let val = {};
              attributes.map((attribute) => attribute.view === true ? val[attribute.name] = true : attribute)
              setExportAttributes(val)
              setExportPopup(true)
            }}
            >{t("exportExcel")}</AddButton>
            </div>
          </AddButton>
        )}
        
          {formInput.filter((item) => item.type === "select" && (item.filter ?? true) === true)?.length>0 && <AddButton onClick={()=> setShowDrawer(true)}>
            <FilterIcon></FilterIcon>
            <span>{t("filter")}</span>
          </AddButton>}
          {/* {formInput.map((item, index) => {
            return item.type === "select" && (item.filter ?? true) === true && <FormInput customClass={"filter"} placeholder={item.placeHolder} value={filterView[item.name]} key={`input` + index} id={item.name} {...item} type={item.filterType ?? "multiSelect"} onChange={filterChange} />;
          })} */}
        </Filters>
      </ButtonPanel>}
      {chart && <DynamicBarChart t={t} fetchData={fetchChartData} transformData={transformData} title={shortName} />}
        {cases && <CasesContainer>
          <CaseItem>
            <div className="num">{users?.data?.cases?.totalCase}</div>
            <div>{t("Cases")}</div>
          </CaseItem>
          <CaseItem>
            <div className="num">{users?.data?.cases?.newCase} / {users?.data?.cases?.totalCase}</div>
            <div>{t("New case")}</div>
          </CaseItem>
          <CaseItem>
            <div className="num">{users?.data?.cases?.openCase} / {users?.data?.cases?.totalCase}</div>
            <div>{t("Open case")}</div>
          </CaseItem>
          <CaseItem>
            <div className="num">{users?.data?.cases?.closedCase}</div>
            <div>{t("Closed case")}</div>
          </CaseItem>
        </CasesContainer>}
            {/* <thead></thead> */}
            {!display && groupedData?.length > 0 ? (
              groupedData.map((group,index) => {
                return (
                  <>
                    <GroupHeader key={index} index={index} className={group.status}>
                      <GetIcon icon={group.status}></GetIcon>
                      {t(group.status)}
                    </GroupHeader>
                  <ScrollContainerLayout key={index} index={index}>
        <ScrollLayout className="groupList">
          
                    <Table>
                    <thead>
                      <Tr className="no-border">
                      {selectPrivilege && <ActionBox>
                          <More
                            key={`select-${data._id}`}
                            className="selected-privilege"
                          >
                            {/* <FormInput placeholder={""} key={`input` + 0} id={data._id} index={0} value={group.items?.filter((item)=> !selectedValue[item._id]).length<=0} type="checkbox" onChange={(sl, event)=> {
                              let value = {};
                              group.items?.map((item)=> value[item._id]=event);
                              setSelectedValue(value)
                            }} />  */}
                            <Checkbox theme={themeColors} checked={data?.filter((item)=> !selectedValue[item._id]).length<=0} onChange={(event) => {
                              let value = {};
                              data?.map((item)=> value[item._id]=event.target.checked);
                              setSelectedValue(value)
                            }} className="medium"></Checkbox>
                          </More>
                      </ActionBox>}
                        {attributes.map((attribute, index) => {
                          return attribute.view === true ? <Th key={shortName + attribute.name + index}>{t(attribute.label)}</Th> : "";
                        })}
                      </Tr>
                    </thead>
                    <tbody>
                      {group.items?.map((item, index) => (
                        <React.Fragment key={`${shortName}-${index}`}>
                          <TableRowWithActions slNo={index} attributes={attributes} data={item} pinnedRows={false} />
                        </React.Fragment>
                      ))}
                    </tbody>
                  </Table>
                  </ScrollLayout>
                  </ScrollContainerLayout>
                  </>
                );
              })
            ) : (
              !display && <ScrollContainerLayout>
        <ScrollLayout>
              <table>
                <thead>
                  <Tr className="head no-border">
                  {selectPrivilege && <Th> <ActionBox>
                          <More
                            key={`select`}
                            className="selected-privilege"
                          >
                            {/* <FormInput placeholder={""} key={`input` + 0} id={0} index={0} value={data?.filter((item)=> !selectedValue[item._id]).length<=0} type="checkbox" onChange={(sl, event)=> {
                              let value = {};
                              data?.map((item)=> value[item._id]=event);
                              setSelectedValue(value)
                            }} />  */}
                            <Checkbox theme={themeColors} checked={data?.filter((item)=> !selectedValue[item._id]).length<=0} onChange={(event) => {
                              let value = {};
                              data?.map((item)=> value[item._id]=event.target.checked);
                              setSelectedValue(value)
                            }} className="medium"></Checkbox>
                          </More>
                      </ActionBox></Th>}
                    {attributes.map((attribute, index) => {
                      // console.log(attribute.view === true ? `${attribute.label} - ${t(attribute.name)}` : "");
                      // console.log("selected language: " + t("Add New Equipments"));
                      return attribute.view === true ? <Th key={shortName + attribute.name + index}>{t(attribute.label)}</Th> : "";
                    })}
                  </Tr>
                </thead>
                <tbody>
                  {data?.length > 0 &&
                    data.map((item, index) => (
                      <React.Fragment key={`${shortName}-${index}`}>
                        <TableRowWithActions slNo={index} attributes={attributes} data={item} pinnedRows={false} />
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
                {groupedData?.length > 0 ? null : ((!chart && (!users.data || !users.data?.data || users.data?.data.length === 0)) || (chart && (!data || data.length===0))) && <NoData>{t("notFound", { page: t(shortName) })}</NoData>}
              </ScrollLayout>
              </ScrollContainerLayout>
            )}
          
      {!display && count > currentLimit ? (
        <Filters className="full">
          <Count>
            <ArrowButton
              theme={themeColors}
              onClick={() => {
                setCurrentIndex((prev) => (prev > 9 ? prev - (currentLimit === 0 ? count : currentLimit) : 0));
              }}
            >
              <PreviousIcon />
            </ArrowButton>
            {t("showing", {
              from: currentIndex + 1,
              to: Math.min(currentIndex + (currentLimit === 0 ? count : currentLimit), count),
              count: count,
            })}
            <ArrowButton
              theme={themeColors}
              onClick={() => {
                setCurrentIndex((prev) => (prev + 10 > count ? currentIndex : currentIndex + (currentLimit === 0 ? count : currentLimit)));
              }}
            >
              <NextIcon />
            </ArrowButton>
          </Count>
          <FormInput customClass={"filter records"} placeholder={`show`} value={currentLimit} key={`input0`} id={"itemsPage"} {...pageLimitFilter} onChange={pageLimitFilterChange} />
        </Filters>
      ) : groupedData?.length > 0 ? null : (
        !display && <Filters theme={themeColors} className="full">
          {count === 0 ? <Count></Count> : <Count>{t("showingData", { count ,records: location.pathname==="/employees"? t("Employees"): location.pathname==="/team" ? (count === 1 ? t("Person") : t("Persons")): location.pathname==="/news" ? (count === 1 ? t("message") : t("messages")) : t("records")})}</Count>}
        </Filters>
      )}
      {display && <DisplayInformations udpateView={udpateView} isEditingHandler={dataVal ? isEditingHandler : isCreatingHandler} actions={actions} refresh={refreshView} setMessage={setMessage} setLoaderBox={setLoaderBox} profileImage={profileImage} formMode={formMode} formView={formView} attributes={attributes} data={dataVal} display={display} tabName={shortName} />}
      {showDetails && (
        <PopupView
          // Popup data is a JSX element which is binding to the Popup Data Area like HOC
          popupData={<DisplayInformations udpateView={udpateView} isEditingHandler={isEditingHandler} actions={actions} refresh={refreshView} setMessage={setMessage} setLoaderBox={setLoaderBox} profileImage={profileImage} formMode={formMode} formView={formView} attributes={attributes} data={openData.data} api={api} />}
          themeColors={themeColors}
          closeModal={() => {
            setShowDetails(false);
          }}
          setMessage={setMessage}
          setLoaderBox={setLoaderBox}
          profileImage={profileImage}
          itemTitle={typeof itemTitle === "string" ? { name: itemTitle, type: "text" } : itemTitle}
          openData={openData} // Pass selected item data to the popup for setting the time and taking menu id and other required data from the list item
          customClass={formView}
        ></PopupView>
      )}
      {exportPopup && (
        <PopupView
          // Popup data is a JSX element which is binding to the Popup Data Area like HOC
          popupData={<ExportPopupData attributes={attributes} t={t} themeColors={themeColors} selectedValue={exportAttributes} setSelectedValue={setExportAttributes} />}
          themeColors={themeColors}
          closeModal={() => {
            setExportPopup(false);
          }}
          setMessage={setMessage}
          setLoaderBox={setLoaderBox}
          profileImage={profileImage}
          itemTitle={t("exportExcel")}
          actionButton={true}
          actionFunction={() => setMessage({ type: 2, content: t("export"), proceed: t("exportNow"), onProceed: toExcel, data: currentIndex })}
          actionButtonName="exportExcel"
        ></PopupView>
      )}
      {isCreating && <CrudForm formMode={formMode} formView={formView} api={api} formType={"post"} header={t("addNewTitle", { label: t(shortName ? shortName : "Form") })} formInput={formInput} formValues={addValues} formErrors={errroInput} submitHandler={submitHandler} isOpenHandler={isCreatingHandler} isOpen={isCreating} openData={users?.data?.data?.length>0 ? {data: users.data.data[0]} : false} ></CrudForm>}
      {isEditing && <CrudForm delPrivilege={delPrivilege} deleteHandler={deleteHandler} setMessage={setMessage} formMode={formMode} formView={formView} api={api} formType={"put"} updateId={updateId} header={t("update", { label: t(shortName ? shortName : "Form") })} formInput={formInput} formErrors={errroInput} formValues={updateValues} submitHandler={updateHandler} isOpenHandler={isEditingHandler} isOpen={isEditing} actions={actions} setLoaderBox={setLoaderBox} setRefreshVal={setRefreshVal} refreshView={refreshView} openData={openData} ></CrudForm>}
      {action.data && <Manage setMessage={setMessage} setLoaderBox={setLoaderBox} onClose={closeManage} {...action}></Manage>}
      {bulkUplaod && showBulkUplad && (
        <CrudForm
          bulkUpload={true}
          delPrivilege={delPrivilege}
          deleteHandler={deleteHandler}
          setMessage={setMessage}
          setLoaderBox={setLoaderBox}
          formMode={"single"}
          formView={formView}
          api={api}
          formType={"put"}
          updateId={updateId}
          header={t("bulkUpload", { label: t(shortName ? shortName : "Form") })}
          formInput={formInput}
          formErrors={errroInput}
          formValues={updateValues}
          currentApi={currentApi}
          submitHandler={() => {
            refreshView(currentIndex);
            setIsEditing(false);
            setShowBulkUplad(false);
          }}
          isOpenHandler={() => setShowBulkUplad(false)}
          isOpen={isEditing}
        ></CrudForm>
      )}
      {showLoader && <Loader></Loader>}
      {showSublist && subAttributes?.item?.attributes?.length > 0 && <SubPage closeModal={closeModal} setMessage={setMessage} setLoaderBox={setLoaderBox} subAttributes={subAttributes}></SubPage>}
      {showDrawer && <Drawer setShowDrawer={setShowDrawer} formInput={formInput} filterView={filterView} setFilterView={setFilterView} onChange={filterChange} />}
    </RowContainer>
  );
};
export default ListTable;

const ExportPopupData = ({attributes, t, themeColors, selectedValue, setSelectedValue}) => {

  return (
    <ExportPopupContainer>
      {attributes.map((attribute, index) => {
        return attribute.view === true ? 
        <div style={{display:'flex', alignItems:'center'}}>
          <Checkbox theme={themeColors} checked={selectedValue[attribute.name] && selectedValue[attribute.name]} onChange={(event) => setSelectedValue({...selectedValue, [attribute.name]: event.target.checked})} className="medium"></Checkbox>
          <div key={index}>{t(attribute.label)}</div> 
        </div>
        : null;
      })}
    </ExportPopupContainer>
  )
}
